import { PAGINATION } from "constant/common"
import { PaginationMetadata, UserInfo, VendorInfo } from "types"
import slug from "slug"

export const getFullName = (user?: UserInfo | VendorInfo) => {
  if (!user) return "Pom Guest"
  return user.name || user.email
}

export const getPagination = (pagination: {
  count?: number
  offset?: number
  limit?: number
}): PaginationMetadata => {
  const { count = 0, offset = 0, limit = PAGINATION.limit } = pagination
  const totalPage = Math.ceil(count / limit)
  const page = Math.floor(offset / limit) + 1
  return { totalPage, limit, page, count, offset }
}

export type OptionStrGenerate = {
  length?: number
  prefix?: string
  suffix?: string
  upCase?: boolean
  lowerCase?: boolean
}

export const strGenerate = (options?: OptionStrGenerate): string => {
  let result = ""
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
  const charactersLength = characters.length
  for (let i = 0; i < (options?.length || 10); i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  if (options?.prefix) {
    result = `${options?.prefix}${result}`
  }
  if (options?.suffix) {
    result = `${result}${options?.suffix}`
  }
  if (options?.upCase && !options?.lowerCase) {
    result = result.toUpperCase()
  }
  if (options?.lowerCase && !options?.upCase) {
    result = result.toLowerCase()
  }
  return result
}

export const genSlug = (str?: string, needDefault?: boolean) => {
  if (!needDefault && (!str || str.length <= 0)) return str?.trim()
  return slug(str?.trim() || strGenerate({ length: 10, lowerCase: true }))
}

export const rgbaToHex = ({ r, g, b, a }: any) => {
  const toHex = (value: any) =>
    value?.toString(16).padStart(2, "0").toUpperCase()
  if (!toHex(r)) return ""
  return `#${toHex(r)}${toHex(g)}${toHex(b)}${toHex(Math.round(a * 255))}`
}

export const hexToRgba = (hex: string) => {
  // Remove the # if present
  hex = hex.replace(/^#/, "")

  // Parse R, G, B, A values
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)
  const a = parseInt(hex.substring(6, 8), 16) / 255 // Convert alpha to 0-1 range

  return { r, g, b, a: parseFloat(a.toFixed(2)) } // Round alpha to 2 decimal places
}
